export default "__VITE_ASSET__C42b0i$f__"